var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { justify: "center", dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "6", md: "4" } },
        [
          _c("v-select", {
            attrs: {
              items: _vm.transportTypes,
              "item-text": "name",
              "item-value": "id",
              "error-messages": _vm.modelTransportTypeValidation,
              label: _vm.$t(
                "delegation.form.fields.transport.transportType.name"
              ),
              readonly: _vm.$store.state.Delegation.readonly === true,
              "persistent-hint": "",
              hint: _vm.validationTransportType,
              "background-color":
                _vm.validationTransportType !== null ? "blue lighten-5" : null
            },
            model: {
              value: _vm.contextTransportType,
              callback: function($$v) {
                _vm.contextTransportType = $$v
              },
              expression: "contextTransportType"
            }
          })
        ],
        1
      ),
      _vm.modelTransportType !== 1
        ? _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "4" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.settlementTypes(_vm.modelTransportType),
                  "error-messages": _vm.modelSettlementTypeIdValidation,
                  label: _vm.$t(
                    "delegation.form.fields.transport.settlementType.name"
                  ),
                  readonly: _vm.$store.state.Delegation.readonly === true
                },
                model: {
                  value: _vm.contextSettlementTypeId,
                  callback: function($$v) {
                    _vm.contextSettlementTypeId = $$v
                  },
                  expression: "contextSettlementTypeId"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "12", md: "4" } },
        [
          _vm.modelTransportType === 2
            ? _c("ajax-booking-flight-select", {
                attrs: {
                  model: _vm.contextBookingId,
                  "validation-message": _vm.modelBookingIdValidation,
                  fileId: _vm.contextFileId,
                  ticketNumber: _vm.contextBookingTicket,
                  readonly: _vm.$store.state.Delegation.readonly === true
                },
                on: {
                  "update:model": function($event) {
                    _vm.contextBookingId = $event
                  },
                  importRouteTo: _vm.importRouteTo,
                  importRouteBack: _vm.importRouteBack,
                  "update:fileId": function($event) {
                    _vm.contextFileId = $event
                  },
                  "update:file-id": function($event) {
                    _vm.contextFileId = $event
                  },
                  fileUploaded: _vm.addFileToDelegationFiles,
                  fileRemoved: _vm.removeFileFromDelegationFiles,
                  "update:ticketNumber": function($event) {
                    _vm.contextBookingTicket = $event
                  },
                  "update:ticket-number": function($event) {
                    _vm.contextBookingTicket = $event
                  }
                }
              })
            : _vm._e(),
          _vm.modelTransportType === 3
            ? _c("ajax-booking-rail-select", {
                attrs: {
                  model: _vm.contextBookingId,
                  fileId: _vm.contextFileId,
                  "validation-message": _vm.modelBookingIdValidation,
                  ticketNumber: _vm.contextBookingTicket,
                  readonly: _vm.$store.state.Delegation.readonly === true
                },
                on: {
                  "update:model": function($event) {
                    _vm.contextBookingId = $event
                  },
                  "update:fileId": function($event) {
                    _vm.contextFileId = $event
                  },
                  "update:file-id": function($event) {
                    _vm.contextFileId = $event
                  },
                  importRailRoute: _vm.importRailRoute,
                  fileUploaded: _vm.addFileToDelegationFiles,
                  fileRemoved: _vm.removeFileFromDelegationFiles,
                  "update:ticketNumber": function($event) {
                    _vm.contextBookingTicket = $event
                  },
                  "update:ticket-number": function($event) {
                    _vm.contextBookingTicket = $event
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }